import { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import Level3Title  from '../../../../app/common/components/title/Level3Title';
import Evening from '../../Medias/Evening.mp3';
import Imagination from '../../Medias/Imagination.mp3';
import NoFace from '../../Medias/NoFace.mp3';
import {useNavigate , createSearchParams } from 'react-router-dom';
import {useSearchParams} from 'react-router-dom';
import {useIntl} from 'react-intl';



const musiques = [
  { label: "Evening", value: Evening },
  { label: "Imagination", value: Imagination },
  { label: "NoFace", value: NoFace },
];

export default function ConfigurationSVI({ CISID, tel, telperso }: { CISID: string, tel?: string, telperso?: string }) {
  const [audioSrc, setAudioSrc] = useState("");
  const audioRef = useRef<HTMLAudioElement>(null);
  const navigate = useNavigate();
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  console.log(tel);

  useEffect(() => {
    if (audioRef.current && audioSrc) {
      audioRef.current.load();
    }
  }, [audioSrc]);

  
  const goToReclamation = ()=>{ 
    searchParams.append('TemplateReclamation',  "demande_de_changement_de_musique_d_attente");
    searchParams.append('ServiceId', CISID );
    const fileName = audioSrc.split("/").pop();
    if(fileName != null){
        const baseName = fileName.split(".")[0];
        searchParams.append('music', baseName+".mp3" );
        navigate({
            pathname: `/reclamations`,
            search: createSearchParams(searchParams).toString(),
        });
    } 
  };
  
  return (
    <Container fluid className="mt-4 mb-5">
        <Card className="DetailsTelephonie col-md-6">
            <Card.Header>
                <Card.Title>
                    <Level3Title title={intl.formatMessage({id: 'TELEPHONIE.SVI.TITLE'})} />
                </Card.Title>
            </Card.Header>

            <Card.Body>
                {intl.formatMessage({id: 'TELEPHONIE.SVI.DESCRIPTION'})}
                <Form>
                    <Row className="mb-3">
                        <Col md={12} className="mt-5">
                            <Form.Label>{intl.formatMessage({id: 'TELEPHONIE.SVI.YOUR_NUMBER'})}</Form.Label>
                            <Form.Control disabled type="text" value={telperso}/>
                        </Col>

                        <Col md={12} className="mt-5">
                            <Form.Label>{intl.formatMessage({id: 'TELEPHONIE.SVI.STANDARD_NUMBER'})}</Form.Label>
                            <Form.Control disabled type="text" value={tel}/>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12} className="mt-5">
                            <Form.Label>{intl.formatMessage({id: 'TELEPHONIE.SVI.YOUR_OPTION'})}</Form.Label>
                        </Col>
                    </Row>

                    <Row className="mb-3 align-items-center">
                        <Col md={12} className="mt-5">
                            <Form.Select
                            value={audioSrc}
                            onChange={(e) => setAudioSrc(e.target.value)}
                            >
                            <option value="">{intl.formatMessage({id: 'TELEPHONIE.SVI.SELECT_MUSIC'})}</option>
                            {musiques.map((m, index) => (
                                <option key={index} value={m.value}>
                                {m.label}
                                </option>
                            ))}
                            </Form.Select>
                        </Col>
                        

                        {audioSrc && (
                            <Row className="mt-5">
                                <Col md={12} >
                                    <audio ref={audioRef} controls className="w-100">
                                        <source src={audioSrc} type="audio/mpeg" />
                                        {intl.formatMessage({id: 'TELEPHONIE.SVI.AUDIO_NOT_SUPPORTED'})}
                                    </audio>
                                </Col>
                            </Row>
                        )}

                        
                        <Col md={12} className="mt-5">
                            <Button disabled={ audioSrc === "" } onClick={ ()=>{ goToReclamation() } } variant="primary">
                                {intl.formatMessage({id: 'TELEPHONIE.SVI.USE_AS_HOLD_MUSIC'})}
                            </Button>
                        </Col>
                    </Row>

                </Form>
            </Card.Body>
        </Card>
    </Container>
  );
}



